module.exports = __webpack_public_path__ + "img/icon_picture.af8f0138.svg";